<template>
       <div class="list">
          <div class="tabBar">
            <div class="tabName" :class="{'active': ptIndex === item.id}" v-for="(item, idx) in tabList" :key="idx" @click="changeData(idx, item.id)">{{item.typeName}}</div>
          </div>
          <div class="rightContent">
            <div class="rightTopContent">
                <template v-if="list.length">
                    <div class="apiBlock" v-for="item in list" :key="item.id">
                    <div class="topBox">
                        <div class="topLeftBox">
                        <img class="apiIcon" src="../../../assets/images/apiOpenIcon.png" />
                        <div>
                            <div class="tit">{{item.name}}</div>
                            <div class="method">{{getMethText(item.method)}}</div>
                        </div>
                        </div>
                        <span class="blueBtn" @click="handleOpen(item.id)">申请开通</span>
                    </div>
                    <div class="botBox">
                        <div>
                        <span>访问地址：</span>
                        <em>{{item.address}}</em>
                        </div>
                        <div><span>详情：</span>{{item.remark}}</div>
                    </div>
                    </div>
                </template>
                <template v-else>
                <Nodata />
                </template>  
            </div>
            <div class="pageBox">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>  
          </div>
          
        </div>
</template>
<script>
import { fetchInterfaceTypeList, fetchInterfaceList, fetchInterfaceApply } from '@/api/api'
import Nodata from '@/components/noData.vue'
export default {
  data() {
    return {
      total: 0,
      pageNum: 1,
      pageSize: 10,
      list: [],
      tabList:[
        {
          typeName:'全部',
          id: 'all',
        },
      ],
      ptIndex: 'all',
    }
  },
  created() {
    this.getTypeList()
    this.getList()
  },
  components:{
      Nodata,
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    getList() {
      let params = {
        pageNum: this.pageNum-1,
        pageSize: this.pageSize,
      }
      if(this.ptIndex === 'all') {
        params.typeId = ''
      }else {
        params.typeId = this.ptIndex  
      }
      fetchInterfaceList(params).then(res => {
        this.list = res.data.content
        this.total = Number(res.data.totalElements)
      })
    },
    
    getMethText(num) {
      let str = ''
      if(num === 1) {
        str='POST'
      }else if(num === 2) {
        str='GET'
      }else if(num === 3) {
        str='PUT'
      }else if(num === 4) {
        str='DELETE'
      }
      return str
    },
    getTypeList() {
      fetchInterfaceTypeList().then(res => {
          this.tabList = [...this.tabList, ...res.data]
      })
    },
    changeData(idx, id) {
        this.ptIndex = id
        this.pageNum = 1
        this.getList()
    },
    handleOpen(id) {
      let params={
          id: id
      }
      fetchInterfaceApply(params).then(res => {
        if(res.code == 1) {
          this.$message.success('申请成功');
        }else {
          this.$message.error(res.msg);
        }
      })
    },
  }
}
</script>
<style scoped>
  .list{
    /* border: 1px solid #f00; */
    height: calc(100vh - 250px);
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .list::-webkit-scrollbar { width: 0 !important }

.rightTopContent{
  width: 100%;
  height: calc(100vh - 300px);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: flex-start;
  overflow-y: scroll;
}
.rightTopContent::-webkit-scrollbar { width: 0 !important }
.apiBlock{
  width: 500px;
  background: #FFFFFF;
  box-shadow: 1px 5px 16px 0px rgba(220,221,236,0.3);
  border-radius: 8px;
  padding: 24px 30px;
  box-sizing: border-box;
  margin: 0px 0 16px 0;
  margin-right: 10px;
  height: 230px;
}
.apiBlock .topBox{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.apiBlock .topBox .blueBtn{
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #FFFFFF;
  background: #0F5EFF;
  border-radius: 23px;
  cursor: pointer;
  height: 46px;
  line-height: 46px;
  padding: 0 29px;
}
.topLeftBox .apiIcon{
  width: 75px;
  height: 75px;
  margin-right: 20px;
}
.topLeftBox{
  display: flex;
  flex-direction: row;
  flex: 1;
}
.topLeftBox .tit{
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #121E30;
}
.topLeftBox .method{
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #0F5EFF;
  padding: 7px 20px;
  background: #EDF2FF;
  display: inline-block;
  border-radius: 2px;
  margin-top: 17px;
}
.botBox{
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #121E30;
  padding-left: 6px;
  line-height: 32px;
  padding-top: 10px;
}
.botBox span{
  color: #909DB1;
}
.botBox em{
  font-style: normal;
  word-break: break-all;
}

.pageBox{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}


/deep/ .noData{
  height: calc(100vh - 380px)!important;
}



.list{
    /* border: 1px solid #f00; */
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .tabBar{
      width: 180px;
      border-right: 1px solid #E1E1F0;
      height: 100%;
      /* border-right: 1px solid #F00; */
  }
  
  .tabName{
    width: 180px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    font-size: 18px;
    /* font-family: "Source Han Sans CN"; */
    font-weight: 400;
    margin: 25px 0;
  }
  .tabName.active{
      color: #225EFD;
      border-right: 2px solid #225EFD;
  }
  .tabName:hover{
      color: #225EFD;
      border-right: 2px solid #225EFD;
  }
  .rightContent{
      flex: 1;
  }
  .rightTopContent{
      /* border: 1px solid #00f; */
  }
</style>




// WEBPACK FOOTER //
// src/views/console/components/ServiceMarket.vue